import { Link } from '@tanstack/react-router';
import { Sparkles, ArrowRight } from 'lucide-react';
import { describeStrings } from '../utils/describe.strings';

interface SituationCapturedProps {
  sessionId: string;
}

export function SituationCaptured({ sessionId }: SituationCapturedProps) {
  return (
    <div className="mt-16 border border-slate-200/60 bg-gradient-to-b from-blue-50/60 to-white rounded-2xl p-6 shadow-sm relative overflow-hidden">
      <div className="absolute top-0 start-0 end-0 h-1 bg-gradient-to-r from-blue-400 to-indigo-500" />
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
          <Sparkles className="h-5 w-5 text-blue-600" aria-hidden />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-slate-900 mb-1">
            {describeStrings.situationCaptured.heading}
          </h3>
          <p className="text-sm text-slate-600 mb-4">
            {describeStrings.situationCaptured.body}
          </p>
          <Link
            to="/interactions/debrief-v2/$id/gather"
            params={{ id: sessionId }}
            className="inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-md text-sm font-medium bg-button-primary text-white hover:bg-button-primary-hover transition-colors"
          >
            {describeStrings.situationCaptured.continue}
            <ArrowRight className="h-4 w-4 ms-1 rtl:rotate-180" aria-hidden />
          </Link>
        </div>
      </div>
    </div>
  );
}
